'use client';

import { toast } from 'sonner';

import type { UpdaterState } from '@/app/sdk';

import { globalStore } from '@/app/globalStore';

/**
 * Applies updater state and mirrors production SDK transition toasts (manual check,
 * available, ready, error). Used by both live IPC and dev mocks.
 */
export function applyUpdaterStateWithToasts(nextState: UpdaterState): void {
  const previousPhase = globalStore.updaterPhase;
  globalStore.setUpdaterState(nextState);

  if (previousPhase === nextState.phase) {
    return;
  }

  if (nextState.phase === 'checking' && nextState.trigger === 'manual') {
    toast.info('Checking for updates...');
    return;
  }

  if (nextState.phase === 'available') {
    const versionLabel = nextState.targetVersion ? `v${nextState.targetVersion}` : 'a new version';
    toast.info(`Update ${versionLabel} is available`);
    return;
  }

  if (nextState.phase === 'readyToInstall') {
    toast.success('Update downloaded. Restart when ready to install.');
    return;
  }

  if (nextState.phase === 'error') {
    toast.error(nextState.errorMessage ?? 'Update check failed');
  }
}
